import React from 'react';
import Modal from 'react-modal';
import closeIcon from '../../assets/images/close-icon.svg';
import './index.scss';

export interface IAppModal {
  isOpen: boolean;
  onClose: (e: any) => void;
  hideCloseIcon?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  children?: React.ReactNode;
  adjustToContent?: boolean;
}

const AppModal = ({
  isOpen,
  onClose,
  size = 'md',
  children,
  hideCloseIcon = false,
  adjustToContent = false
}: IAppModal) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName={`modalOverlay`}
      className={`modalContent ${size}${adjustToContent ? ' adjust-to-content' : ''}`}
    >
      {!hideCloseIcon && (
        <img
          src={closeIcon}
          alt="close_icon"
          className="tw-absolute tw-top-1 tw-right-1 tw-z-10 tw-cursor-pointer tw-w-4"
          role="presentation"
          onClick={onClose}
        />
      )}
      {children}
    </Modal>
  );
};

export default AppModal;
